/* KleenKick V3 — Pagina produs: galerie thumbs + selector pachete */
(function () {
  'use strict';

  /* ---- Galerie: thumbnail swap ---- */
  var mainImg = document.getElementById('kk-pdp-main-img');
  var thumbs = document.querySelectorAll('[data-kk-thumb]');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImg) mainImg.src = t.getAttribute('data-kk-thumb');
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* ---- Selector pachete (variant-driven) ---- */
  var form = document.getElementById('kk-pdp-form');
  if (!form) return;

  var hiddenId = form.querySelector('[data-kk-variant-id]');
  var btnPrice = form.querySelector('[data-kk-btn-price]');
  var shipnote = form.querySelector('[data-kk-shipnote]');
  var radios = form.querySelectorAll('[data-kk-variant-option]');

  function update(radio) {
    if (!radio) return;
    if (hiddenId) hiddenId.value = radio.value;
    if (btnPrice) btnPrice.textContent = radio.getAttribute('data-price-display');

    if (shipnote) {
      var free = radio.getAttribute('data-free-shipping') === 'true';
      if (free) {
        shipnote.innerHTML = '<span class="kk-pdp__shipnote-on">✓ Transport GRATUIT inclus</span>';
      } else {
        shipnote.textContent = 'Adaugă încă un kit și transportul e GRATUIT.';
      }
    }

    radios.forEach(function (r) {
      var card = r.closest('.kk-pdp__card');
      if (card) card.classList.toggle('is-selected', r.checked);
    });
  }

  radios.forEach(function (r) {
    r.addEventListener('change', function () { update(r); });
  });

  /* sincronizare la load (dacă browserul a păstrat o selecție) */
  var checked = form.querySelector('[data-kk-variant-option]:checked');
  if (checked) update(checked);
})();
